<div class="sidebar-panel" [ngClass]="{ open: isOpen, wide: wideSidebar }">
  <div class="sidebar-panel-header">
    <div class="back" *ngIf="showBackButton">
      <sui-button
        size="sm"
        variant="secondary"
        [leadingIcon]="['fas', 'chevron-left']"
        (click)="back()"
      >
        {{ "sidebar-panel.button.back" | translate }}
      </sui-button>
    </div>
    <div class="icon" *ngIf="!showBackButton">
      <fa-icon class="icon" *ngIf="icon" [icon]="icon"></fa-icon>
    </div>
    <h4>{{ title }}</h4>
    <fa-icon
      class="close-button"
      [icon]="['fas', 'times-circle']"
      (click)="closeSidebar()"
    ></fa-icon>
  </div>

  <!-- popoverBoundary: sui-combobox (and other popover-based controls) rendered
       inside the panel mount their overlay here instead of <body>, so they share
       the panel's stacking/positioning context — same treatment as dialog content
       panes. The panel toggles open like a dialog, so it needs the same scoping. -->
  <div
    class="sidebar-panel-content"
    [class.no-toolbar]="buttons.length == 0 || !buttons || hideButtons"
    popoverBoundary
  >
    <ng-template #panelContainer></ng-template>
  </div>

  <div class="sidebar-panel-footer" *ngIf="buttons.length > 0 && !hideButtons">
    <app-panel-toolbar [buttons]="buttons"></app-panel-toolbar>
  </div>
</div>
